import { createRouter, createWebHistory } from 'vue-router'
import store from '../store/index.js'

var adminOn = false

let routes = [

    {
        path:'/',
        name:'',
        component: () => import('../views/Business.vue')
    },
    {
        path:'/client',
        name:'Client',
        component: () => import('../views/Client.vue'),


    },
    {
        path:'/business_appointments',
        name:'BAppointments',
        component: () => import('../views/BAppointments.vue')

    },
    {
        path: '/new_appointment',
        name: 'Appointment',
        component: () => import('../views/Appointment.vue')
    },
    {
        path: '/profile',
        name: 'Profile',
        component: () => import('../views/Profile.vue')
    },
    {
        path: '/history',
        name: 'History',
        component: () => import('../views/History.vue')
    },
    {
      path: '/business_signin',
      name: 'Business',
        component: () => import('../views/Business.vue')
    },
    {
        path: '/payment',
        name: 'Payment',
        component: () => import('../views/Payment.vue')

    },
    {
        path: '/support',
        name: 'Support',
        component: () => import("../views/Support.vue"),
        beforeEnter(to, from, next) {
            //console.log('Route guard beforeEnter /SUPPORT route matched')
            if(adminOn) {
                next()
            } else {
                let passw = prompt('To have access to admin functions \nPlease type Admin password')
                if(passw.match('serpi_606#')) {
                    //console.log(to)
                    adminOn = true
                    next()
                } else {
                    //this.$router.push('/')
                    alert('Sorry wrong password...')
                    next(from)
                }
            }
        },
    },
    {
      path: '/features' ,
      name: 'Features',
      component: () => import('../views/Features.vue')
    },
    {
        path:'/business_offices',
        name:'Offices',
        component: ()=> import('../views/Offices.vue')
    },
    {
        path: '/faq',
        name: 'FaQ',
        component: () => import('../views/FaQ.vue')
    },
    {
        path: '/bfaq',
        name: 'BFaQ',
        component: () => import('../views/BFaQ.vue')
    },
    {
        path: '/new_office',
        name: 'NewOffice',
        component: () => import('../views/NewOffice.vue')
    },
    {
        path: '/new_business',
        name: 'NewBusiness',
        component: () => import('../views/NewBusiness.vue')
    },
    {
        path: '/petprofile',
        name: 'PetProfileForm',
        component: () => import('../views/PetProfileForm.vue')
    },
    {
        path: '/petfiles/:pfid',
        name: 'PetFiles',
        component: () => import('../views/PetFiles.vue')
    },
    {
        path: '/:pathMatch(.*)*',
        component: () => import('../views/NotFoundPage.vue')
    }

]

const router = createRouter({
  history: createWebHistory(),
  routes
})
//******************************* the read QR code should init app to client
router.afterEach((to) => {
    if(to.path === '/client') {
        //console.log('Global guard: afterEach ...everything is resolved for route: ', to.path)
        if(store.getters.getBusiness) {
            store.commit('setBusinessUi',!store.getters.getBusiness)
        }
    }
})

export default router
